<template>
    <div>
        <x-navigation ref="navigation"></x-navigation>
        <book-sidebar ref="booksidebar"></book-sidebar>
        <perfil-sidebar ref="perfilsidebar"></perfil-sidebar>
        <v-main v-if="user_loaded">
            <router-view />
        </v-main>
    </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            user_loaded : (state) => state.userData.user_loaded,
        }),
    },
}
</script>
<style scoped lang="scss">
    .v-main{
        @media (min-width: 960px){
            margin-left: 144px;
        }
        @media (max-width: 959px){
            margin-bottom: 110px;
        }
        @media (max-width: 599px){
            margin-bottom: 0px;
            padding: 0 0 50px 0!important;
        }
    }
</style>
